import React from "react";
import ContactComponent from "../Components/Contact";

const Contact = () => {
  return (
    <div>
      <ContactComponent />
    </div>
  );
};

export default Contact;
